import { forwardRef } from '@chakra-ui/react'
import { css, Global } from '@emotion/react'
import JoditEditor from 'jodit-react'
import { useMemo } from 'react'

import {
  TextAlignCenterString,
  TextAlignJustifyString,
  TextAlignLeftString,
  TextAlignRightString,
  TextBoldString,
  TextItalicsString,
  TextOrderedListString,
  TextUnorderedListString,
} from '../../icons'
import { cs_cz } from './cs_cz'

const getCustomIcon = (name: string, control: any, clearName: string) => {
  switch (clearName) {
    case 'bold':
      return TextBoldString
    case 'italic':
      return TextItalicsString

    case 'image':
      return

    case 'left':
      return TextAlignLeftString
    case 'right':
      return TextAlignRightString
    case 'justify':
      return TextAlignJustifyString
    case 'center':
      return TextAlignCenterString

    case 'ul':
      return TextUnorderedListString
    case 'ol':
      return TextOrderedListString
  }
}

export const TextEditor = forwardRef(
  ({
    placeholder,
    toolbar = true,
    minHeight = '100px',
    ...props
  }: {
    placeholder?: string
    toolbar?: boolean
    value: string
    minHeight?: string
    onBlur?: (value: string) => void
    onChange?: (value: string) => void
  }, ref) => {
    const config = useMemo(() => {
      const config = {
        readonly: false, // all options from https://xdsoft.net/jodit/docs/,
        placeholder: (placeholder as any) || 'Vložte text...',
        statusbar: false,
        font: '12px Inter',
        width: '100%',
        maxWidth: '100%',
        minHeight,
        toolbar,
        language: 'cs_cz',
        i18n: {
          cs_cz,
        },
        events: {
          getIcon: getCustomIcon,
        },
      }
      return config
    }, [placeholder])

    return (
      <>
        <Global
          styles={css`
            .jodit-container:not(.jodit_inline) {
              border-color: var(--ok-colors-gray-400) !important;
              border-radius: var(--ok-radii-md) !important;
              overflow: hidden !important;
            }

            .jodit-toolbar__box:not(:empty),
            .jodit-toolbar__box {
              background-color: var(--ok-colors-gray-50) !important;
              border-radius: var(--ok-radii-md) var(--ok-radii-md) 0 0 !important;
            }

            .jodit-toolbar-button .jodit-icon {
              width: 1rem !important;
              height: 1rem !important;
            }

            svg.jodit-icon {
              fill: var(--ok-colors-blue-800);
              stroke: var(--ok-colors-blue-800);
              stroke-width: 0 !important;
            }
          `}
        />

        <JoditEditor
          ref={ref}
          config={config}
          {...props}
        />
      </>
    )
  },
)
